import { render, staticRenderFns } from "./MarkupTable.vue?vue&type=template&id=cdb8faee"
import script from "./MarkupTable.vue?vue&type=script&lang=js"
export * from "./MarkupTable.vue?vue&type=script&lang=js"
import style0 from "./MarkupTable.vue?vue&type=style&index=0&id=cdb8faee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports